import {handlers as dummyHandlers} from './dummy'
import {handlers as partsSpecificConfigsHandlers} from './parts-specific-configs'
import {handlers as partsHandlers} from './parts'

export const handlers = [
  ...dummyHandlers,
  ...partsHandlers,
  ...partsSpecificConfigsHandlers,
]
